import axios from 'axios';
import { toast } from 'react-toastify';
import { store } from '../store/index';
import { showLoader, hideLoader } from '../store/loader/actions';
import { clearTemporaryStorage } from 'helpers/helpers';
import i18n from '../i18n';

const baseURL = process.env.REACT_APP_API_URL || 'https://api.nehir.uz/api';

const apiClient = axios.create({
	baseURL,
	withCredentials: false,
	headers: {
		'Content-Type': 'application/json',
		'Accept': 'application/json',
	},
});

apiClient.interceptors.request.use((config) => {
	const token = localStorage.getItem('token');

	if (token) {
		config.headers['Authorization'] = `Bearer ${token}`;
	}

	// config.headers['Accept-Language'] = language;
	// config.headers['Language'] = language;

	return config;
}, (error) => {
	return Promise.reject(error);
});

apiClient.interceptors.response.use(
	(response) => response,
	(error) => {
		handleGlobalErrors(error);
		return Promise.reject(error);
	}
);

async function request(method, url, data = {}, settings = { loader: true, notification: false }) {
	if (settings.loader) store.dispatch(showLoader());

	try {
		const config = { method, url };
		if (method.toLowerCase() === 'get') {
			config.params = data;
		} else {
			config.data = data;
		}

		if (settings.isFile) {
			config.headers = { 'Content-Type': 'multipart/form-data' };
		}

		// Обработка скачивания файлов
		if (settings.isDownload) {
			config.responseType = 'blob';
		}

		const response = await apiClient(config);

		if (settings.notification && method.toLowerCase() !== 'get') {
			toast.dismiss();
			toast.success(i18n.t('success'));
		}

		return response;

	} catch (error) {
		return error.response;
	} finally {
		if (settings.loader) store.dispatch(hideLoader());
	}
}

export const GET = (url, payload = {}, settings = { loader: true }) =>
	request('get', url, payload, settings);

export const POST = (url, payload = {}, settings = { loader: true, notification: true }) =>
	request('post', url, payload, settings);

export const PUT = (url, payload = {}, settings = { loader: true, notification: true }) =>
	request('put', url, payload, settings);

export const PATCH = (url, payload = {}, settings = { loader: true, notification: true }) =>
	request('patch', url, payload, settings);

export const DELETE = (url, payload = {}, settings = { loader: true, notification: true }) => {
	return request('delete', url, payload, settings);
};

export const FILE = (url, payload, settings = { loader: true }) =>
	request('post', url, payload, { ...settings, isFile: true });

export const FILE_D = (url, settings = { loader: true }) =>
	request('get', url, {}, { ...settings, isDownload: true });

function handleGlobalErrors(error) {
	toast.dismiss();
	
	if (!error.response) return;

	const { status, data } = error.response;

	let message = i18n.t('error');

	if (typeof data === 'string') {
		message = data;
	} else if (Array.isArray(data)) {
		message = data.join(', ');
	} else if (typeof data === 'object' && data !== null) {
		if (data.error) {
			message = data.error;
		} else if (data.detail) {
			message = data.detail;
		} else if (data.message) {
			message = data.message;
		} else {
			const values = Object.values(data).flat();
			message = values.length > 0 ? values.join(', ') : i18n.t('error');
		}
	}

	switch (status) {
		case 400:
		case 403:
			toast.error(message);
			break;
		case 401:
			toast.error(message);
			handleAuthError();
			break;
		case 404:
			toast.error(i18n.t('not_found'));
			break;
		case 500:
			const serverMsg = [data?.file, data?.line, data?.message].filter(Boolean).join(' ') || i18n.t('error');
			toast.error(serverMsg);
			break;
		case 502:
			toast.error(`Обновление сервера. Подождите`);
			break;
		default:
			toast.error(message);
			break;
	}
}
function handleAuthError() {
	clearTemporaryStorage();
	// toast.error(i18n.t('login_or_password_invalid'));

	if (!window.location.pathname.includes('login')) {
		window.location.href = `${window.location.origin}/auth/login`;
	}
}

export function httpOk(response) {
	return response?.status >= 200 && response?.status < 300;
}